import React from 'react';
import Section from '../common/Section';
import Carousel from '../common/Carousel';
import { Quote } from 'lucide-react';

const testimonials = [
    {
        name: "Mr. Sandip More",
        role: "Founder, Wings Institute",
        content: "The digital marketing support provided by the team has helped Wings Institute reach the right students and significantly improve our online visibility. Their strategic approach, creative content, and consistent follow-ups have generated quality inquiries for our courses. We truly appreciate their professionalism and commitment to results."
    },
    {
        name: "Director",
        role: "Founder, NarayanFX",
        content: "The WordPress website delivered for NarayanFX perfectly represents our creative vision. The design, performance, and overall presentation exceeded our expectations. The team understood our requirements clearly and delivered the project smoothly and on time. Highly recommended for creative businesses."
    },
    {
        name: "Director",
        role: "Sausar Farmer Producer Organization (SFPO)",
        content: "The website developed for SFPO has helped us digitally represent our farmers and promote events like the Orange Festival effectively. The team delivered a user-friendly and visually appealing website that aligns with our rural and agricultural values. Their support and execution were excellent."
    }
];

const Testimonials = () => {
    const testimonialItems = testimonials.map((t, i) => (
        <div key={i} className="bg-[#0a0a0a] border border-white/5 p-8 md:p-12 rounded-3xl text-center relative mx-auto max-w-2xl">
            <Quote className="w-12 h-12 text-[#bebd19] opacity-20 mx-auto mb-6" />
            <p className="text-xl md:text-2xl text-gray-300 font-medium leading-relaxed mb-8">
                "{t.content}"
            </p>
            <div>
                <h4 className="text-white font-bold text-lg">{t.name}</h4>
                <p className="text-[#bebd19] text-sm font-semibold">{t.role}</p>
            </div>
        </div>
    ));

    return (
        <Section className="bg-black relative overflow-hidden">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#bebd19]/5 rounded-full blur-[120px] pointer-events-none" />

            <div className="container mx-auto px-4 relative z-10">
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Client Success Stories</h2>
                    <p className="text-gray-400 max-w-2xl mx-auto text-lg">
                        Don't just take our word for it. Here's what our partners say about working with us.
                    </p>
                </div>

                <Carousel items={testimonialItems} autoPlay={true} interval={6000} />
            </div>
        </Section>
    );
};

export default Testimonials;
